import { Injectable } from '@angular/core';
import {  ProjectDto } from '@shared/service-proxies/service-proxies';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProjectNameServiceService {
  isShowProjectName : ProjectDto;
  showProjectName : BehaviorSubject<ProjectDto> = new BehaviorSubject<ProjectDto>(null)

  createCard(name:any){
    if(name.length !== 0) this.isShowProjectName = name;
   }

   getCardList(){
    return this.isShowProjectName;
   }
  constructor() { }
}
